import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('kraken', {
  cherry: 'barnacle',
  lemon: 'pufferfish',
  orange: 'compass',
  bell: 'lantern',
  star: 'kraken_wild',
  seven: 'anchor',
  gem: 'pearl',
  scatter: 'whirlpool_scatter',
  money: 'treasure_hoard',
});

/** Kraken's Lair — GENERATED by scaffoldSlot from
 *  content/slots/kraken.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const KRAKEN_THEME: Theme = {
  id: 'kraken',
  name: 'Kraken\'s Lair',
  palette: {
    accent: 0x2fa4b8,
    secondary: 0x1a3a52,
    warm: 0xf0c860,
    frameFill: 0x0c1a24,
    bgGradientTop: 0x123040,
    bgGradientBottom: 0x050d14,
    dimOverlay: 0x030810,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Barnacle', glyph: '🐚', tint: 0x8a9ba0, weight: 5, textureAlias: 'kraken:cherry',
        winVideoAlias: 'kraken:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Pufferfish', glyph: '🐡', tint: 0xe89858, weight: 5, textureAlias: 'kraken:lemon',
        winVideoAlias: 'kraken:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Compass', glyph: '🧭', tint: 0xc9a24b, weight: 4, textureAlias: 'kraken:orange',
        winVideoAlias: 'kraken:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Lantern', glyph: '🪔', tint: 0xe0b050, weight: 3, textureAlias: 'kraken:bell',
        winVideoAlias: 'kraken:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Kraken', glyph: '🐙', tint: 0x3a8a8a, weight: 2, textureAlias: 'kraken:star',
        winVideoAlias: 'kraken:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Anchor', glyph: '⚓', tint: 0x9aa6ad, weight: 2, textureAlias: 'kraken:seven',
        winVideoAlias: 'kraken:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Pearl', glyph: '🦪', tint: 0xf0e6e0, weight: 2.5, textureAlias: 'kraken:gem',
        winVideoAlias: 'kraken:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Whirlpool', glyph: '🌀', tint: 0x2fa4b8, weight: 0.5, textureAlias: 'kraken:scatter',
        winVideoAlias: 'kraken:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Treasure Hoard', glyph: '🪙', tint: 0xf0c860, weight: 1, textureAlias: 'kraken:money',
        winVideoAlias: 'kraken:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x0c1a24, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x2fa4b8, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf0c860, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x0c1a24, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x1a3a52, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x2fa4b8, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf0c860, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x0c1a24, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf0c860, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x2fa4b8, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf0c860, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf0c860, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'kraken:bg', path: 'environment/kraken.png' },
      columnBackground: { alias: 'kraken:column_bg', path: 'reel/kraken_column_bg.png' },
      border: { alias: 'kraken:border', path: 'brand/border_underwater.png' },
    },
  },
};
